import OrdersTabs from '@components/orders/OrdersTabs'

const UserTabs = () => {
  return (
    <div className="shared-container h-96 lg:h-full">
      <div className="thin-scroll h-full overflow-auto">
        <div className="p-6 pb-0">
          <OrdersTabs />
        </div>
      </div>
    </div>
  )
}

export default UserTabs
